//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import commNav from '@/components/nav/index.vue'
    import empty from '@/components/empty/index.vue'
    export default {
        components: {
            commNav,
            empty
        },
        data() {
            return {
              activeName: this.$store.state.isPay?this.$store.state.isPay:0,
              deleteid:'',
              deletetype:'',
                isConfirm: false,
                isPay:this.$store.state.isPay?this.$store.state.isPay:0,
                orderlist: [],//待支付
                allOrederList: [],//全部
                commNav: true,
                commTab: true,
                isempty: false,
                message: '暂无订单',
                pagination: 1,
                pageCount: 0,
                paginations: 1,
                pageCounts: 0,
                paginationsx: 1,
                pageCountsx: 0,
                noDataText: '',
                scrollerTop: {
                    top: '42px'
                }
            }
        },
        // 生命周期之挂载完成
        methods: {
            init(){
                this.refresh();
            },
            onItemClick (index) {
                // this.$router.push("/paymentSteps");
                if(index == 1){
                    this.isPay = 1;
                  this.$store.state.isPay=1;
                }else if(index==0){
                    this.isPay = 0;
                  this.$store.state.isPay=0;
                }else if(index==2){
                  this.isPay = 2;
                  this.$store.state.isPay=2;
                }
                this.refresh();
            },
            goPay(id,type,state,ordertype){
//              未撤回状态才可查看详情
                if(state=='1'||state=='2'){
                  this.$toastMsg("订单已撤回，不可查看详情");
                  return;
                }else{
                  if(type == 5){
                    //app线上 clinic 线下
                    if(
                      ordertype=='clinic'
                    ){
                      this.$toastMsg("线下订单，不可查看详情");
                      return;
                    }
                    this.$router.push({path: '/myOrderDetailsYF',query: {id: id,befrom: 'orderList',paidTypes:8}});
                    this.$store.state.addressId=id;
                  }else{
                    this.$router.push({path: '/myOrderDetailsWZ',query: {id: id}});
                  }
                }
            },
          goBudject(id,type){
            if(type == 5){
              this.$router.push({path: '/judgement',query: {id: id,}});
            }else{
              this.$router.push({path: '/judgement',query: {id: id,selecttype:'WZ'}});
            }
          },
          /*物流*/
          goLogistics(id,type){
            this.$router.push({path: '/logistics',query: {id: id,}});
          },
          delettd(){
            let id=this.deleteid;
            let type=this.deletetype;
            let params = {};
            if(type==5){
              params={
                orderId :id,
                type:2
              };
            }else{
              params={
                orderId :id,
                type:1
              }
            }
            let _this=this;
            _this.$doRequest("/api/orderinfo/patientDeleteOrder", params,res=> {
              if(res.result==1){
                _this.$toastMsg("删除成功");
                _this.isConfirm=false;
                _this.refresh();
              }
            })
          },
          deleteOrder(id,type){
            if(true){
              this.isConfirm=true;
              this.deleteid=id;
              this.deletetype=type;
            }else{
              this.isConfirm=false;
            }

//              this.$vux.confirm.show({
//                type: "warning",
//                title: '系统提示',
//                content: '确认删除吗？',
//                onConfirm(id,type) {
//                  this.delettd(id, type);
//                  //点击确定0要执行的事件
//                },
//                onCancel() {
//                  //点击取消要执行的事件
//                  this.delettd(id, type);
//                }
//              })
//            this.$confirm('此操作将永久删除该订单, 是否继续?', '提示', {
//              confirmButtonText: '确定',
//              cancelButtonText: '取消',
//              type: 'warning',
//              center: true
//            }).then(() => {
//              let params = {};
//              if(type==5){
//                params={
//                  orderId :id,
//                  type:2
//                };
//              }else{
//                params={
//                  orderId :id,
//                  type:1
//                }
//              }
//              this.$doRequest("/api/orderinfo/patientDeleteOrder", params,res=> {
//                if(res.result==1){
//                  this.$toastMsg("删除成功");
//                  this.refresh();
//                }
//              })
//            }).catch(() => {
//              this.$toastMsg("取消删除");
//            })
            },
            //待支付
            getOrderList(done){
                let id = this.$store.state.userInfo.id;
                let params = {
                    pagination : this.pagination,
                    patientid: id,
                    paystate: '1'
                };
                this.$doRequest("/api/PlacingOrder/queryMyOrders", params,res=>{
                    if(this.pagination == 1){
                        this.orderlist = [];
                    }
                    for(var i=0;i<res.pageVal.length;i++){
                        if(res.pageVal[i].paystate == '1' && res.pageVal[i].orderstate != '4'){
                            this.orderlist.push(res.pageVal[i])
                        }
                    }
                    if(this.orderlist == '' || this.orderlist.length == 0){
                        this.isempty = true;
                    }else{
                        this.isempty = false;
                    }
                    this.pageCount = res.pageCount;
                    if(typeof(done) == 'function'){
                        done();
                    }
                })
            },
          //待评论
          getPinglunList(done){
            let id = this.$store.state.userInfo.id;
            let params = {
              pagination : this.paginationsx,
              patientid: id,
              isComment: '2'
            };
            this.$doRequest("/api/PlacingOrder/queryMyOrders", params,res=>{
              if(this.paginationsx == 1){
                this.orderlist = res.pageVal;
              }else{
                for(var i=0;i<res.pageVal.length;i++){
                  this.orderlist.push(res.pageVal[i]);
                }
              }
              if(this.orderlist == '' || this.orderlist.length == 0){
                this.isempty = true;
              }else{
                this.isempty = false;
              }
              this.pageCountsx = res.pageCount;
              if(typeof(done) == 'function'){
                done();
              }
            })
          },

            //全部
            getAllOrderList(done){
                let id = this.$store.state.userInfo.id;
                let params = {
                    pagination : this.paginations,
                    patientid: id
                };
                this.$doRequest("/api/PlacingOrder/queryMyOrders", params,res=>{
                    if(this.paginations == 1){
                        this.allOrederList = res.pageVal;
                    }else{
                        for(var i=0;i<res.pageVal.length;i++){
                            this.allOrederList.push(res.pageVal[i]);
                        }
                    }
                    if(this.allOrederList == '' || this.allOrederList.length == 0){
                        this.isempty = true;
                    }else{
                        this.isempty = false;
                    }
                    this.pageCounts = res.pageCount;
                    if(typeof(done) == 'function'){
                        done();
                    }
                })
            },
            refresh(done){
                if(this.isPay==0){
                    setTimeout(()=>{
                        this.pagination = 1;
                        this.getOrderList(done);
                    },500)
                }else if(this.isPay==1){
                    setTimeout(()=>{
                        this.paginations = 1;
                        this.getAllOrderList(done);
                    },500)
                }else if( this.isPay == 2){
                  setTimeout(()=>{
                    this.paginationsx = 1;
                    this.getPinglunList(done);
                  },500)
                }
            },
            infinite(done){
                if(this.isPay==0){
                    this.pagination++;
                    setTimeout(()=>{
                        this.$refs.my_scroller.finishInfinite(true);
                        if(this.pagination > this.pageCount){
                            this.noDataText = '没有更多订单信息了';
                        }else{
                            this.getOrderList(done);
                        }
                    },500)
                }else if(this.isPay==1){
                    this.paginations++;
                    setTimeout(()=>{
                        this.$refs.my_scroller.finishInfinite(true);
                        if(this.paginations > this.pageCounts){
                            this.noDataText = '没有更多订单信息了';
                        }else{
                            this.getAllOrderList(done);
                        }
                    },500)
                }else if(this.isPay==2){
                  this.paginationsx++;
                  setTimeout(()=>{
                    this.$refs.my_scroller.finishInfinite(true);
                    if(this.paginationsx > this.pageCountsx){
                      this.noDataText = '没有更多订单信息了';
                    }else{
                      this.getPinglunList(done);
                    }
                  },500)
                }
            }
        },
        //生命周期之创建完成
        created: function(){
            if (this.$route.query.source == 'commNav') {
                this.commNav = true;//从导航跳转（有nav没有tab）
                this.commTab = false;
            } else if(this.$route.query.source == 'qy'){
                this.commNav = false;
                this.commTab = false;//从取药（没有tab并且没有nav）
                this.scrollerTop = {
                    top: '0px'
                }
            } else {
                this.commTab = true;
                this.commNav = false;//从我的（有tab没有nav）
            }
            this.$isLogin(window.location.search.substr(1), this.init);
            document.title = '我的订单';
        },
    }



// WEBPACK FOOTER //
// ./src/views/myOrderList/index.vue